// src/PopupPage.tsx
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

type PopupPayload = { userId: number; mode: string };

export default function PopupPage() {
  const { search } = useLocation(); // HashRouter에서도 쿼리를 제대로 줌

  const payload = useMemo<PopupPayload | null>(() => {
    const p = new URLSearchParams(search).get('payload');
    try {
      return p ? JSON.parse(decodeURIComponent(p)) : null;
    } catch {
      return null;
    }
  }, [search]);

  return <pre>{JSON.stringify(payload, null, 2)}</pre>;
}
